export const ArrowRight = ({ fill = '#fff' }: { fill?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <path
      fill={fill}
      d="M9.99967 3.33398L9.05968 4.27398L12.113 7.33398H1.33301V8.66732H12.113L9.05301 11.7273L9.99967 12.6673L14.6663 8.00065L9.99967 3.33398Z"
    />
  </svg>
);
